// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IEmailVisibilityEnumDto } from './email-visibility-enum-dto.g';

export const peerVisibilityDto = {
    visibleToProjectPeers: 'visibleToProjectPeers',
    emailVisibility: 'emailVisibility',
    userPhotoAsProfileFallback: 'userPhotoAsProfileFallback',
} as const;

export type TPeerVisibilityDto = (typeof peerVisibilityDto)[keyof typeof peerVisibilityDto];

export interface IPeerVisibilityDto {
    [peerVisibilityDto.visibleToProjectPeers]: boolean | null;
    [peerVisibilityDto.emailVisibility]: IEmailVisibilityEnumDto | null;
    [peerVisibilityDto.userPhotoAsProfileFallback]: boolean | null;
}

export class PeerVisibilityDto
    implements IPeerVisibilityDto
{
    [peerVisibilityDto.visibleToProjectPeers]: boolean | null = null;
    [peerVisibilityDto.emailVisibility]: IEmailVisibilityEnumDto | null = null;
    [peerVisibilityDto.userPhotoAsProfileFallback]: boolean | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IPeerVisibilityData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[peerVisibilityDto.guid] = modelData[peervisibilityData.guid];
    }

    static create(modelData?: any | null): IPeerVisibilityDto | null {
        return modelData ? new PeerVisibilityDto(modelData) : null;
    }
}
